var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8417 21.5293C32.6917 21.5293 35 23.7988 35 26.5988C35 29.3972 32.6917 31.6667 29.8417 31.6667C26.9934 31.6667 24.6834 29.3972 24.6834 26.5988C24.6834 23.7988 26.9934 21.5293 29.8417 21.5293ZM17.1249 24.4369C18.3733 24.4369 19.3866 25.4325 19.3866 26.6589C19.3866 27.8837 18.3733 28.8809 17.1249 28.8809H7.26165C6.01333 28.8809 5 27.8837 5 26.6589C5 25.4325 6.01333 24.4369 7.26165 24.4369H17.1249ZM10.1583 5C13.0083 5 15.3166 7.26948 15.3166 10.0678C15.3166 12.8678 13.0083 15.1373 10.1583 15.1373C7.30999 15.1373 5 12.8678 5 10.0678C5 7.26948 7.30999 5 10.1583 5ZM32.74 7.84749C33.9867 7.84749 35 8.84304 35 10.0678C35 11.2943 33.9867 12.2898 32.74 12.2898H22.8767C21.6284 12.2898 20.6151 11.2943 20.6151 10.0678C20.6151 8.84304 21.6284 7.84749 22.8767 7.84749H32.74Z",
    fill: "#5D7285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.16627cacb8fa439501584024f01c854e.svg";
export { ForwardRef as ReactComponent };